/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import './ThayDoiPassBank.scss'
import Notify from '../../../../../component/Notify/Notify'
import Loading from '../../../../../component/Loading/Loading'
import { useUser } from '../../../../../component/UserProvider/UserProvider'
import { getFromlocalstorage } from '../../../../../component/MaHoaDuLieu/MaHoaDuLieu'

const ThayDoiPassBank = () => {
  const initialData =
    JSON.parse(getFromlocalstorage('data_u'))

  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [typeNoti, setTypeNoti] = useState('error')
  const [Message, setMessage] = useState('')
  const hasFetched = useRef(false)

  const apiUrl = process.env.REACT_APP_API_BACKEND
  const { user, fetchUser } = useUser()

  useEffect(() => {
    if (initialData && !hasFetched.current) {
      fetchUser(initialData._id)
      hasFetched.current = true
    }
  }, [initialData])

  const hasOldPassword = user
    ? user.withdrawal_password !== 0
    : initialData.withdrawal_password !== 0

  useEffect(() => {
    if (!hasOldPassword) {
      setOldPassword('')
    }
  }, [hasOldPassword])

  const handleSubmit = e => {
    e.preventDefault()

    if (hasOldPassword && !oldPassword) {
      setMessage('กรุณากรอกรหัสผ่านถอนเงินเดิม')
      setTypeNoti('error')
      return
    }

    if (!newPassword) {
      setMessage('กรุณากรอกรหัสผ่านใหม่')
      setTypeNoti('error')
      return
    }

    if (newPassword !== confirmPassword) {
      setMessage('รหัสผ่านยืนยันไม่ตรงกัน')
      setTypeNoti('error')
      return
    }
  }

  const handleUpdatePassword = async () => {
    setLoading(true)

    const url = `${apiUrl}/postmkruttien/${initialData._id}`

    const body = hasOldPassword
      ? {
          withdrawal_password_old: oldPassword,
          withdrawal_password: newPassword
        }
      : {
          withdrawal_password: newPassword
        }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })

      const result = await response.json()

      if (response.ok) {
        setMessage('เปลี่ยนรหัสผ่านสำเร็จ')
        setTypeNoti('success')

        await fetchUser(initialData._id)

        setOldPassword('')
        setNewPassword('')
        setConfirmPassword('')
      } else {
        setMessage(result.message)
        setTypeNoti('error')
      }
    } catch (error) {
      console.error('loikhigoiapi', error)
      setTypeNoti('error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='change-password'>
        <div className='steps'>
          {/* Step 1 */}
          <div className='step success'>
            <div className='step-head'>
              <div className='step-line'>
                <i className='step-line-inner' />
              </div>

              <div className='step-icon'>
                <i className='step-icon-inner'>✔</i>
              </div>
            </div>

            <div className='step-main'>
              <div className='step-title'>
                กรอกข้อมูล
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className='step process'>
            <div className='step-head'>
              <div className='step-line'>
                <i className='step-line-inner' />
              </div>

              <div className='step-icon'>
                <div className='step-icon-inner'>
                  2
                </div>
              </div>
            </div>

            <div className='step-main'>
              <div className='step-title'>
                เสร็จสิ้น
              </div>
            </div>
          </div>
        </div>

        <form
          className='form'
          onSubmit={handleSubmit}
        >
          {hasOldPassword && (
            <div className='form-item'>
              <label className='form-label'>
                รหัสผ่านถอนเงินปัจจุบัน
              </label>

              <div className='form-content'>
                <input
                  type='password'
                  className='form-input'
                  placeholder='กรุณากรอกรหัสผ่านถอนเงินปัจจุบัน'
                  value={oldPassword}
                  onChange={e =>
                    setOldPassword(e.target.value)
                  }
                />
              </div>
            </div>
          )}

          <div className='form-item'>
            <label className='form-label'>
              รหัสผ่านใหม่
            </label>

            <div className='form-content'>
              <input
                type='password'
                className='form-input'
                placeholder='กรอกรหัสผ่านใหม่'
                value={newPassword}
                onChange={e =>
                  setNewPassword(e.target.value)
                }
              />
            </div>
          </div>

          <div className='form-item'>
            <label className='form-label'>
              ยืนยันรหัสผ่าน
            </label>

            <div className='form-content'>
              <input
                type='password'
                className='form-input'
                placeholder='ยืนยันรหัสผ่านใหม่'
                value={confirmPassword}
                onChange={e =>
                  setConfirmPassword(e.target.value)
                }
              />
            </div>
          </div>

          <div className='form-actions'>
            <button
              type='submit'
              className='btn primary'
              onClick={handleUpdatePassword}
            >
              ยืนยัน
            </button>

            <button
              type='button'
              className='btn info'
              onClick={() => {
                setOldPassword('')
                setNewPassword('')
                setConfirmPassword('')
              }}
            >
              รีเซ็ต
            </button>
          </div>
        </form>
      </div>

      {Message && (
        <Notify
          message={Message}
          type={typeNoti}
          setcontent={setMessage}
        />
      )}

      <Loading isLoading={loading} />
    </>
  )
}

export default ThayDoiPassBank